import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/brand-theme.css';
import './styles.css';
import './utils/axiosConfig';

const rootElement = document.getElementById('root');

const appTree = (
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// react-snap pre-renderiza el HTML en build; si el root ya tiene contenido,
// hidratamos en lugar de re-renderizar para conservar el HTML indexable.
if (rootElement?.hasChildNodes()) {
  ReactDOM.hydrate(appTree, rootElement);
} else {
  ReactDOM.render(appTree, rootElement);
}

// Registrar el Service Worker para Web Push. El SW vive en /service-worker.js
// (CRA copia automáticamente todo lo que esté en client/public). Lo registramos
// con scope '/' para que reciba push aunque el cliente esté en /client/*.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => console.log('[SW] Registrado:', reg.scope))
      .catch((err) => console.warn('[SW] Error al registrar:', err));
  });
}
